import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ControlledRadioGroup, Label } from '@components';

export const PaymentStatus = () => {
  const { t } = useTranslation('subModules/paymentStatus');
  const fields: { [key: string]: string } = t('fields', {
    returnObjects: true,
  }) as { [key: string]: string };

  return (
    <Box
      id="paymentStatus"
      data-testid="paymentStatusSubModule"
      data-tf-sensitive="true"
    >
      <Label required>{t('label')}</Label>

      <ControlledRadioGroup
        name="paymentStatus"
        fields={fields}
        aria-labelledby="payment-status-radio-buttons"
      />
    </Box>
  );
};
